import type { LocalePreference } from '~/interfaces/LocalePreference'
import { createEphemeralStorePersistence } from '~/utils/createEphemeralStorePersistence'
import { supportedLocaleSchema } from '~/utils/supportedLocaleSchema'

const LIFETIME_MS = 365 * 24 * 60 * 60 * 1000

export function useLocalePreference(): LocalePreference {
  const persistence = createEphemeralStorePersistence({
    key: 'mealz.locale',
    schema: supportedLocaleSchema,
    lifetimeMs: LIFETIME_MS
  })

  return { restore: persistence.read, set: persistence.write }
}
